import React from "react";
import { Link } from "react-router-dom";
import errorImg from "../../assets/images/error-img.png";

const Error404 = () => {
  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col md:flex-row items-center justify-center gap-10 px-6 py-12">
      <img
        src={errorImg}
        alt="Error 404"
        className="w-full max-w-[320px] h-auto"
      />
      <div className="text-center md:text-left max-w-md">
        <h1 className="text-7xl font-bold text-emerald-600">404</h1>
        <h3 className="mt-3 text-2xl font-semibold uppercase text-gray-800">
          Sorry, page not found
        </h3>
        <p className="mt-3 text-sm text-gray-500">
          You do not have permission to view this page, or it does not exist.
        </p>
        <Link
          to="/"
          className="inline-block mt-8 px-6 py-3 text-sm font-medium text-white bg-emerald-600 rounded-md hover:bg-emerald-700"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default Error404;
